<template>
  <div>
    <h2 class="font-bold text-18px pb-0.5">Activity</h2>
    <CardTabs class="pt-0 px-0 h-[calc(100%_-_80px)]" v-loading="loading">
      <!-- Table Header -->
      <el-row class="border-b border-grayLight text-gray p-3.5 gap-4 font-medium">
        <ElCol :span="5">
          <TableHeaderCol :sortable="false" field="client">User</TableHeaderCol>
        </ElCol>
        <ElCol :span="5">
          <TableHeaderCol :sortable="false" field="is_simple">Action</TableHeaderCol>
        </ElCol>
        <ElCol :span="10">
          <TableHeaderCol :sortable="false" field="flight_status">Details</TableHeaderCol>
        </ElCol>
        <ElCol :span="4">
          <TableHeaderCol :sortable="false" field="impressions">Timestamp</TableHeaderCol>
        </ElCol>
      </el-row>
      <!-- Table Body -->
      <template v-if="campaignActivity.length > 0">
        <el-scrollbar class="h-[calc(100%_-_40px)]" wrap-style="overflow: auto;">
          <div v-for="(activity, index) in campaignActivity" :key="index" class="p-3.5 text-gray flex items-center">
            <!-- User Column -->
            <ElCol :span="5">
              <div class="flex items-center space-x-0.5">
                <img
                  v-if="activity.user?.user_settings?.company_logo"
                  :src="activity.user.user_settings.company_logo"
                  :alt="activity.user?.name"
                  class="w-[40px] h-[40px] rounded-full shrink-0"
                />
                <svg v-else width="16" height="16">
                  <use :xlink:href="`#avatar`"></use>
                </svg>
                <div>
                  <p class="mb-[5px] text-dark">
                    <strong>{{ activity.user?.name }}</strong>
                  </p>
                  <span>{{ activity.user?.type?.title }}</span>
                </div>
              </div>
            </ElCol>

            <!-- Action Column -->
            <ElCol :span="5">
              <span class="font-medium">{{ activity.formatted_message }}</span>
            </ElCol>

            <!-- Details Column -->
            <ElCol :span="10">
              {{ activity.formatted_details }}.
              <el-popover
                v-if="activity.after && activity.after.status === 1 && activity.comment"
                placement="bottom"
                :width="200"
                trigger="click"
                :content="activity.comment"
              >
                <template #reference>
                  <el-button type="text">View instructions</el-button>
                </template>
              </el-popover>
            </ElCol>

            <!-- Timestamp Column -->
            <ElCol :span="4">
              {{ formatDate(activity.created_at) }}
            </ElCol>
          </div>
          <!-- <pre>{{ campaignActivity }}</pre> -->
        </el-scrollbar>
      </template>

      <!-- No Data State -->
      <NoDataCard v-if="!loading && campaignActivity.length === 0">
        <template slot="title">Activity not available yet</template>
        <template slot="info">Activity will be displayed here once available.</template>
      </NoDataCard>
    </CardTabs>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import NoDataCard from '@/components/social-products/social-boost/parts/NoDataCard.vue'
import CardTabs from '@/components/social-products/social-boost/parts/CardTabs.vue'
import TableHeaderCol from '@/components/tabledata/table-header-col'

export default {
  components: {
    NoDataCard,
    CardTabs,
    TableHeaderCol,
  },
  computed: {
    ...mapGetters('socialBoostActivity', ['campaignActivity', 'loading']),
  },
  methods: {
    async init() {
      this.$store.dispatch('socialBoostActivity/getCampaignActivity', this.$route.params.id)
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleString()
    },
  },
  created() {
    this.init()
  },
}
</script>
